import { createAsyncThunk } from '@reduxjs/toolkit';
import { gamificationApi } from 'api';
import {
  ITrackActivityPayload,
  ITrackActivityResponse,
  IAchievementWithProgress,
  IGamificationSummary,
} from 'modules/core/types/gamification';

import { ACTION_PREFIX } from './actionPrefix.const';

export const trackActivityThunk = createAsyncThunk<ITrackActivityResponse, ITrackActivityPayload>(
  `${ACTION_PREFIX.GAMIFICATION}/trackActivity`,
  async (payload, { dispatch }) => {
    const { data } = await gamificationApi.trackActivity(payload);

    dispatch(fetchAchievementsThunk());

    return data;
  },
);

export const fetchAchievementsThunk = createAsyncThunk<IAchievementWithProgress[]>(
  `${ACTION_PREFIX.GAMIFICATION}/fetchAchievements`,
  async () => {
    const { data } = await gamificationApi.getAchievements();

    return data;
  },
);

export const fetchSummaryThunk = createAsyncThunk<IGamificationSummary>(
  `${ACTION_PREFIX.GAMIFICATION}/fetchSummary`,
  async () => {
    const { data } = await gamificationApi.getSummary();

    return data;
  },
);
